window.addEventListener("DOMContentLoaded", (e) => {
  const menuItems = document.querySelector(".header__inline-menu").querySelectorAll('details')
  menuItems.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true)
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open")
    })

    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open")
    })
  })

  })

  const faqsSectionEls = document.querySelectorAll('[data-module="faqs"]')
  const faqCollapseAll = (itemEls, excludedItemEl) => {
    const excludedIndex = excludedItemEl.getAttribute('data-index')
    console.log(excludedIndex)
    itemEls.forEach(itemEl => {
      const itemIndex = itemEl.getAttribute('data-index')
      console.log(itemIndex === excludedIndex ? `maintain ${itemIndex}` : `collapse ${itemIndex}`)
      if (itemIndex !== excludedIndex) {
        itemEl.open = false
      }
    })
  }
  faqsSectionEls.length && faqsSectionEls.forEach(faqsSectionEl => {
    const questionEls = faqsSectionEl.querySelectorAll('.js-collapse')
      const isAllowMultiple = faqsSectionEl.hasAttribute('data-allow-multiple')
      if (!isAllowMultiple && questionEls.length) {
        questionEls.forEach(questionEl => {
          const questionTriggerEl = questionEl.querySelector('.js-collapse-trigger')
          questionTriggerEl.addEventListener('click', () => {
            faqCollapseAll(questionEls, questionEl)
          })
        })
      }
  })

  const newsletterFormEls = document.querySelectorAll('[data-module="newsletter-form"]')
  const NewsletterForm = (el) => {
    const IS_SUBSCRIBED_CLASS = 'is-subscribed'
    const IS_SUCCESS_CLASS = 'is-success'
    const IS_ERROR_CLASS = 'is-error'
    const IS_SUBMITTED_CLASS = 'is-submitted'
    const FOCUSED_CLASS = 'is-focused'
    const INPUTTED_CLASS = 'is-inputted'
    const setError = (message = '') => {
      el.classList.remove(IS_SUBSCRIBED_CLASS)
      el.classList.remove(IS_SUCCESS_CLASS)
      el.classList.add(IS_SUBMITTED_CLASS)
      el.classList.add(IS_ERROR_CLASS)
      messageEl.innerText = message || errorMessage
      resetInput()
    }
    const setSubscribed = () => {
      el.classList.remove(IS_ERROR_CLASS)
      el.classList.remove(IS_SUCCESS_CLASS)
      el.classList.add(IS_SUBSCRIBED_CLASS)
      el.classList.add(IS_SUBMITTED_CLASS)
      messageEl.innerText = subscribedMessage
      resetInput()
    }
    const setSuccess = () => {
      el.classList.remove(IS_ERROR_CLASS)
      el.classList.remove(IS_SUBSCRIBED_CLASS)
      el.classList.add(IS_SUCCESS_CLASS)
      el.classList.add(IS_SUBMITTED_CLASS)
      inputEl.setAttribute('readonly', 'readonly')
      messageEl.value = successMessage
      submitEl.setAttribute('hidden', 'true')
      resetInput()
    }
    const resetInput = () => {
      setTimeout(() => {
        el.reset()
        el.classList.remove(INPUTTED_CLASS, FOCUSED_CLASS, IS_SUCCESS_CLASS, IS_ERROR_CLASS, IS_SUBMITTED_CLASS)
        messageEl.innerText = ''
        submitEl.removeAttribute('hidden')
        inputEl.removeAttribute('readonly', 'readonly')
      }, 3000)
    }
    const inputEl = el.querySelector('.js-newsletter-form-input')
    const submitEl = el.querySelector('.js-newsletter-form-submit')
    const messageEl = el.querySelector('.js-newsletter-form-message')
    const subscribeUrl = el.getAttribute('action')
    const errorMessage = el.getAttribute('data-error-message') || ''
    const sucessMessage = el.getAttribute('data-success-message') || ''
    const subscribedMessage = el.getAttribute('data-subscribed-message') || ''
    const listId = el.getAttribute('data-list-id')

    if (!el || !inputEl) return

    inputEl.addEventListener('input', () => {
      inputEl.value ? el.classList.add(INPUTTED_CLASS) : el.classList.remove(INPUTTED_CLASS)
    })
    inputEl.addEventListener('focus', () => {
      el.classList.add(FOCUSED_CLASS)
    })
    inputEl.addEventListener('blur', () => {
      el.classList.remove(FOCUSED_CLASS)
    })
    el.addEventListener('submit', async e => {
      e.preventDefault()
      if (el.classList.contains(IS_SUCCESS_CLASS)) {
        e.stopPropagation()
        return
      }
      if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(inputEl.value)) {
        this.setError()
        return
      }

      const response = await window.fetch(subscribeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `email=${inputEl.value}&g=${listId}`
      })

      if (response.status !== 200) {
        setError()
      } else {
        const data = await response.json()

        if (data.success !== true) {
          setError(data.errors[0])
        } else {
          if (data.data.is_subscribed) {
            setSubscribed()
          } else {
            setSuccess()
          }
        }
      }
    })
  }
  newsletterFormEls.length && newsletterFormEls.forEach(newsletterFormEl => {
    NewsletterForm(newsletterFormEl)
  })

  const handleLazyloadImage = (parent = document.body, offset = 0) => {
    const buildThresholdList = () => {
      let thresholds = []
      let numSteps = 100

      for (let i = 1.0; i <= numSteps; i++) {
        let ratio = i / numSteps
        thresholds.push(ratio)
      }
      thresholds.push(0)
      return thresholds
    }
    const lazyloadImages = parent.querySelectorAll('[data-src]:not(.loaded)')
    const observe = (target) => {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const src = entry.target.getAttribute('data-src')
              const srcset = entry.target.getAttribute('data-srcset')
              if (src) {
                entry.target.setAttribute('src', src)
                if (srcset) {
                  entry.target.setAttribute('srcset', srcset)
                }
                entry.target.classList.add('loaded')
                entry.target.removeAttribute('data-src')
                entry.target.removeAttribute('data-srcset')
                observer.unobserve(entry.target)
              }
            }
          })
        },
        {
          root: null,
          rootMargin: `${window.innerHeight + offset}px 0px 0px 0px`,
          threshold: buildThresholdList(),
        }
      )
      observer.observe(target)
    }
    lazyloadImages.length && lazyloadImages.forEach(lazyloadImage => {
      observe(lazyloadImage)
    })
  }
  const mutationObserver = new MutationObserver((entries) => {
    entries.forEach(entry => {
      handleLazyloadImage(entry.target, 20)
    })
  })
  mutationObserver.observe(document.body, { subtree: true, childList: true })
  handleLazyloadImage()
})
